import { cloneDeep } from 'lodash'
import { recalcDataByColumns, rearrangeQueryData } from '../column'


// fetchManagerData(columns, pathname, {
// 	exportColumns,
// 	tabName: newTabName, sampleData, pageNum, numPerPage, search, filter, sort, category: me.category,
// 	onEnd, onSuccess, sourceComponent, showFetchSpinner: config.showFetchSpinner,
// 	onFailure: ({ errorMessage }) => { Ext.toast(errorMessage), console.error(errorMessage) }
// })
// { list, total, pageNum, tabCounts, selectValues }
export const fetchManagerData = (columns, pathname, {
	exportColumns,
	tabName, sampleData, pageNum = 1, numPerPage = Tyan.psnCfg.numPerPage,
	search, filter, sort, category = null,
	onSuccess, onEnd, sumFields, ...rest
} = {}) => {
	const data = rearrangeQueryData(columns, exportColumns, {
		name: pathname.substring(1), tabName, pageNum, numPerPage, search, filter, sort,
		roles: Tyan.menus.allPaths[pathname] && Tyan.menus.allPaths[pathname].roles, category, sumFields,
	})

	for (const [n, v] of Object.entries(data)) /* v == undefined */ ((!v && v !== 0/*  && v !== '' */) || (typeof v == 'object' && !Object.keys(v).length)) && delete data[n]

	// console.log('sample:', sampleData, category, pageNum, numPerPage)
	if (sampleData) {
		const { id } = category || {}
		let list = cloneDeep(id ? sampleData.filter(({ CategoryID }) => CategoryID === id) : sampleData)
		const total = list.length
		const pages = !numPerPage ? 1 : (Math.ceil(total / numPerPage) || 1)
		const newPageNum = pageNum <= 0 ? 1 : Math.min(pageNum, pages)
		list = !numPerPage ? list : list.slice(numPerPage * (newPageNum - 1), numPerPage * (newPageNum))
		// console.log('list:', list, total, newPageNum)
		setTimeout(() => onSuccess(recalcDataByColumns(exportColumns || columns, { list, total, pageNum: newPageNum })))
	} else {
		// pathname == '/GaugeApplication' && console.log('call data:', data)
		Tyan.doPostEvent('GetManagerData', {
			data,
			...rest,
			onSuccess: onSuccess && ((v) => { onSuccess(recalcDataByColumns(exportColumns || columns, v)) }),
			onEnd: onEnd && ((v) => { onEnd(recalcDataByColumns(exportColumns || columns, v)) }),
		})
	}
}

export const fetchManagerCategories = (pathname, { tabName, sampleCategoriesData, onSuccess, ...rest } = {}) => {
	sampleCategoriesData
		? setTimeout(() => onSuccess({ categories: cloneDeep(sampleCategoriesData) }))
		: Tyan.doPostEvent('GetManagerData', {
			data: {
				name: pathname.substring(1), tabName, dataType: 'categories', roles: Tyan.menus.allPaths[pathname].roles,
			},
			onSuccess, ...rest
		})
}

// 重新组织categories数据，把list数据转换成树状数据
export const regenSampleCategoriesData = sampleCategoriesData => {
	if (!sampleCategoriesData) return undefined

	sampleCategoriesData = cloneDeep(sampleCategoriesData)
	const ret = []
	const map = {}
	const rest = {} // 未找到的父级

	sampleCategoriesData.forEach(category => {
		const { id, parentID } = category
		if (id === undefined) {
			console.error('示例数据错误:分类数据无id')
			return
		}
		if (map[id]) {
			console.error('示例数据错误: 分类数据id重复', id)
			return
		} else
			map[id] = category

		if (rest[id]) {
			category.children = rest[id]
			delete rest[id]
		}

		if (parentID !== undefined) {
			if (map[parentID]) {
				const parent = map[parentID]
				parent.children = parent.children || []
				parent.children.push(category)
			} else {
				rest[parentID] = rest[parentID] || []
				rest[parentID].push(category)
			}
		} else {
			ret.push(category)
		}
	})

	return ret
}
